module.exports = "https://www.gc-qa.gnp.com.mx/1f162a98b409a856df4791633d74d0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/video.png
// module id = 1866
// module chunks = 0